import { render, staticRenderFns } from "./OperatorTrainBlock.vue?vue&type=template&id=4aa8a934"
import script from "./operatorTrainBlock.ts?vue&type=script&lang=js&external"
export * from "./operatorTrainBlock.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports